import { Phone, Mail, Clock, MapPin } from "lucide-react";
import { COMPANY, NAV_LINKS } from "@/data/content";
import { scrollToTarget } from "@/components/site/Reveal";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-charcoal-soft border-t border-white/10 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-brick text-white flex items-center justify-center font-heading font-extrabold text-lg">B</span>
              <span className="font-heading font-extrabold text-lg tracking-tight text-white">
                BBS <span className="text-brick-light">Masonry</span>
              </span>
            </div>
            <p className="mt-5 text-white/55 text-base max-w-md leading-relaxed">
              A family-owned masonry and chimney company serving West Michigan and beyond for over 30 years.
              Quality craftsmanship, honest pricing and free estimates.
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {["Family Owned", "Licensed & Insured", "1-Year Labor Warranty"].map((b) => (
                <span key={b} className="rounded-full bg-white/5 border border-white/10 px-3 py-1.5 text-white/70 text-xs font-semibold">{b}</span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white text-sm uppercase tracking-wider">Explore</h4>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.target}>
                  <button onClick={() => scrollToTarget(l.target)} className="text-white/55 hover:text-brick-light text-sm transition-colors">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white text-sm uppercase tracking-wider">Contact</h4>
            <ul className="mt-4 space-y-3.5">
              <li>
                <a href={COMPANY.phoneHref} className="flex items-start gap-2.5 text-white/55 hover:text-brick-light text-sm transition-colors">
                  <Phone className="w-4 h-4 mt-0.5 text-brick-light shrink-0" /> {COMPANY.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${COMPANY.email}`} className="flex items-start gap-2.5 text-white/55 hover:text-brick-light text-sm transition-colors break-all">
                  <Mail className="w-4 h-4 mt-0.5 text-brick-light shrink-0" /> {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5 text-white/55 text-sm">
                <Clock className="w-4 h-4 mt-0.5 text-brick-light shrink-0" /> {COMPANY.hours}
              </li>
              <li className="flex items-start gap-2.5 text-white/55 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 text-brick-light shrink-0" /> Serving Michigan statewide
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</p>
          <p className="text-white/30 text-xs">Website content includes placeholder information — replace with real business details.</p>
        </div>
      </div>
    </footer>
  );
};
